// Duke's undergraduate majors (#2652, batch 2). Read on 2026-10-01 from
// Duke Admissions' official A to Z list (admissions.duke.edu/academic-
// possibilities/): every entry with a B.A., B.S. or B.S.E.; minors and
// certificates left out. The list names no school per entry, so B.S.E.
// programs (Duke's engineering degree) sit under Pratt and the rest under
// Trinity. Quirks: Psychology is listed twice (kept once); Global Health is a
// co-major with no degree of its own; the named interdepartmental majors
// carry no degree on the list. The KB's majors list was the starting point;
// the official list wins. Typography is plain ASCII.
const majors = {
    "slug": "duke-university",
    "read": "2026-10-01",
    "intro": "Every undergraduate major on Duke's official Majors, Minors, and More list, grouped by the school that offers it, with the degree it leads to. Minors and certificates are left out.",
    "groups": [
        {
            "name": "Trinity College of Arts & Sciences",
            "source": {
                "label": "Duke Undergraduate Admissions, Majors, Minors, and More",
                "url": "https://admissions.duke.edu/academic-possibilities/"
            },
            "majors": [
                {
                    "name": "African & African American Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Art History",
                    "degree": "B.A."
                },
                {
                    "name": "Asian & Middle Eastern Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Biology",
                    "degree": "B.A., B.S."
                },
                {
                    "name": "Biophysics",
                    "degree": "B.A., B.S."
                },
                {
                    "name": "Brazilian & Global Portuguese",
                    "degree": "B.A."
                },
                {
                    "name": "Chemistry",
                    "degree": "B.A., B.S."
                },
                {
                    "name": "Classical Civilization",
                    "degree": "B.A."
                },
                {
                    "name": "Classical Languages",
                    "degree": "B.A."
                },
                {
                    "name": "Computer Science",
                    "degree": "B.A., B.S."
                },
                {
                    "name": "Cultural Anthropology",
                    "degree": "B.A."
                },
                {
                    "name": "Dance",
                    "degree": "B.A."
                },
                {
                    "name": "Earth & Climate Sciences",
                    "degree": "B.A., B.S."
                },
                {
                    "name": "Economics",
                    "degree": "B.A., B.S."
                },
                {
                    "name": "English",
                    "degree": "B.A."
                },
                {
                    "name": "Environmental Sciences",
                    "degree": "B.S."
                },
                {
                    "name": "Environmental Sciences & Policy",
                    "degree": "B.A., B.S."
                },
                {
                    "name": "Evolutionary Anthropology",
                    "degree": "B.A., B.S."
                },
                {
                    "name": "French & Francophone Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Gender, Sexuality & Feminist Studies",
                    "degree": "B.A."
                },
                {
                    "name": "German",
                    "degree": "B.A."
                },
                {
                    "name": "Global Culture & Theory",
                    "degree": "B.A."
                },
                {
                    "name": "Global Health",
                    "degree": null,
                    "note": "Co-major: taken together with another major"
                },
                {
                    "name": "History",
                    "degree": "B.A."
                },
                {
                    "name": "Interdepartmental Major",
                    "degree": "B.A., B.S."
                },
                {
                    "name": "Interdepartmental Major: Ancient Religion & Society - Classical Studies/Religious Studies",
                    "degree": null,
                    "note": "A named interdepartmental major"
                },
                {
                    "name": "Interdepartmental Major: Computational Media - Visual & Media Studies/Computer Science",
                    "degree": null,
                    "note": "A named interdepartmental major"
                },
                {
                    "name": "Interdepartmental Major: Data Science - Computer Science & Math",
                    "degree": null,
                    "note": "A named interdepartmental major"
                },
                {
                    "name": "Interdepartmental Major: Data Science - Computer Science & Statistics",
                    "degree": null,
                    "note": "A named interdepartmental major"
                },
                {
                    "name": "Interdepartmental Major: Linguistics & Computer Science",
                    "degree": null,
                    "note": "A named interdepartmental major"
                },
                {
                    "name": "International Comparative Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Italian Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Linguistics",
                    "degree": "B.A."
                },
                {
                    "name": "Marine Science & Conservation",
                    "degree": "B.A., B.S."
                },
                {
                    "name": "Mathematics",
                    "degree": "B.A., B.S."
                },
                {
                    "name": "Medieval & Renaissance Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Music",
                    "degree": "B.A."
                },
                {
                    "name": "Neuroscience",
                    "degree": "B.A., B.S."
                },
                {
                    "name": "Philosophy",
                    "degree": "B.A."
                },
                {
                    "name": "Physics",
                    "degree": "B.A., B.S."
                },
                {
                    "name": "Political Science",
                    "degree": "B.A."
                },
                {
                    "name": "Program II",
                    "degree": "B.A., B.S."
                },
                {
                    "name": "Psychology",
                    "degree": "B.A., B.S."
                },
                {
                    "name": "Public Policy",
                    "degree": "B.A."
                },
                {
                    "name": "Religious Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Romance Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Russian",
                    "degree": "B.A."
                },
                {
                    "name": "Slavic & Eurasian Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Sociology",
                    "degree": "B.A."
                },
                {
                    "name": "Spanish, Latin American, & Latino/a Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Statistical Science",
                    "degree": "B.A., B.S."
                }
            ]
        },
        {
            "name": "Pratt School of Engineering",
            "source": {
                "label": "Duke Undergraduate Admissions, Majors, Minors, and More",
                "url": "https://admissions.duke.edu/academic-possibilities/"
            },
            "note": "Pratt applicants need calculus coursework; physics is strongly recommended.",
            "noteSource": "apply",
            "majors": [
                {
                    "name": "Biomedical Engineering",
                    "degree": "B.S.E."
                },
                {
                    "name": "Civil Engineering",
                    "degree": "B.S.E."
                },
                {
                    "name": "Electrical & Computer Engineering",
                    "degree": "B.S.E."
                },
                {
                    "name": "Environmental Engineering",
                    "degree": "B.S.E."
                },
                {
                    "name": "IDEAS: Interdisciplinary Engineering & Applied Science",
                    "degree": "B.S.E."
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "B.S.E."
                }
            ]
        }
    ]
};

export default majors;
